'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var confirmDialogComponent = exports.confirmDialogComponent = {
    transclude: true,
    template: require('./confirm-dialog.html'),
    bindings: {
        message: '@?',
        messageTitle: '@?',
        onConfirm: '&',
        onReject: '&',
        onCancel: '&'
    },
    controllerAs: 'vm',
    controller: function controller() {
        var vm = this;
        vm.confirm = confirm;
        vm.reject = reject;
        vm.cancel = cancel;

        function confirm() {
            vm.onConfirm();
        }
        function reject() {
            vm.onReject();
        }
        function cancel() {
            vm.onCancel();
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/common/dialogs/confirm-dialog.js
// module id = 914
// module chunks = 0